import { Component, Inject } from '@angular/core';
import { FORM_DIRECTIVES, CORE_DIRECTIVES, ControlGroup, Control, Validators as AngularValidators } from '@angular/common';
import { RouteParams } from '@angular/router-deprecated';
import { UserService, LoadingService } from '../services';
import { Validators } from '../common/Validators';

@Component({
    selector: 'usermgt',
    template: require('./usrmgt.html'),
    directives: [FORM_DIRECTIVES, CORE_DIRECTIVES],
    providers: [UserService]
})
export class UsrMgtComponent {
    username: string;
    permission: string;
    institutionId: number;
    userMgtForm: ControlGroup;
    alert: any;
    isCampusLabsAdmin: boolean;

    constructor(
        private userSvc: UserService, 
        params: RouteParams, 
        protected loadingService: LoadingService
    ) {
        this.institutionId = parseInt(params.get('id'));

        this.userMgtForm = new ControlGroup({
            institutionId: new Control('', Validators.numeric),
            username: new Control('', AngularValidators.required),
            permission: new Control('', AngularValidators.required)
        });

        this.alert = {
            "txt": '',
            "type": ''
        }

        this.isCampusLabsAdmin = false;

        this.loadingService.startLoad();

        this.userSvc.getAuthenticatedUser().subscribe(
            response => {
                this.isCampusLabsAdmin = (response.sitePermissions === 31);
                this.loadingService.stopLoad();
            });
    }

    setPermission() {
        this.alert.txt = '';
        this.loadingService.startLoad();
        this.userSvc.setPermissions(this.institutionId, this.username, this.permission).subscribe(
            response => {
                this.alert.type = 'success';
                this.alert.txt = 'User Updated';
                this.loadingService.stopLoad();
            },
            err => {
                this.alert.type = 'danger';
                this.alert.txt = 'There was a problem setting the permissions.';
                this.loadingService.stopLoad();
            }
        );
    }
}


/** WEBPACK FOOTER **
 ** ./app/users/UsrMgtComponent.ts
 **/